import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot} from '@angular/router';
import {of} from 'rxjs';
import {RefModelService} from '../../services/ref-model.service';

@Injectable()
export class NodePathResolve {
  constructor(private refModelSvc: RefModelService) {}

  resolve(route: ActivatedRouteSnapshot) {
    const nodePath = route.parent?.data.nodePath;
    if (nodePath) {
      return of(nodePath);
    }
    const refModelId = route.params['refModelId'];
    const nodeId = route.queryParams['node'];

    return this.refModelSvc.fetchNodePath(refModelId, nodeId);
  }
}
